import { Award, Crown, Gem, Medal, Shield, Sparkles, Star, Trophy, type LucideIcon } from 'lucide-react'

/** Preset tier icons - names mirror Tier::ICONS on the backend. */
export const TIER_ICONS: Record<string, LucideIcon> = {
  medal: Medal,
  star: Star,
  crown: Crown,
  gem: Gem,
  trophy: Trophy,
  award: Award,
  shield: Shield,
  sparkles: Sparkles,
}

export const TIER_ICON_NAMES = Object.keys(TIER_ICONS)

export const TIER_FALLBACK_COLOR = '#94A3B8'

export function tierIcon(name?: string | null): LucideIcon {
  return TIER_ICONS[name ?? ''] ?? Medal
}

/**
 * Tinted chip styles from a tier's hex color, following the Badge recipe
 * (bg /10, border /40, text full) via 8-digit hex alpha.
 */
export function tierTint(hex?: string | null): { backgroundColor: string; borderColor: string; color: string } {
  const color = /^#[0-9A-Fa-f]{6}$/.test(hex ?? '') ? (hex as string) : TIER_FALLBACK_COLOR
  return { backgroundColor: `${color}1A`, borderColor: `${color}66`, color }
}
